import { RelevantAlternativeResult } from "models/StatisticsReport";
import generateBackgroundColors from "utility/generateBackgroundColors";
import LineChart from "../Charts/LineChart";

interface RelevantAlternativesProps {
    data: RelevantAlternativeResult
}

const RelevantAlternatives = ({data}:RelevantAlternativesProps) => {

    const chartLabels = data.aggregatedDisplays?.map((element) => element.yearMonth.toString()) ?? [];
    const {baseColorsFormatted} = generateBackgroundColors();
    const periodTotal = new Intl.NumberFormat('nb-NO').format(data.aggregatedDisplays.reduce((sum, element) => sum + element.value, 0));
    const chartDataset = [
        {
            label: "Ikke annonsører",
            data: data.aggregatedDisplays.map((element) => element.value),
            backgroundColor: baseColorsFormatted[0],
            borderColor: baseColorsFormatted[0]
        }
    ];
    return (
        <div className="card mb-4">
            <div className="card-header">
                <h2 className="p2"><big className="fw-bold">{periodTotal}</big> visninger av infoside for ikke-annonsører i ditt område</h2>
            </div>
            <div className="card-body">
                <p className="text-muted mb-3">
                    <small>Visninger av andre bedrifter på dine konkurrenters infosider (ikke annonsører). <a href="https://www.1881.no/annonse-og-reklamevirksomhet/annonse-og-reklamevirksomhet-akershus/annonse-og-reklamevirksomhet-gjettum/abraham-feruz-muse_107209491S1/">Se eksempel</a></small>
                </p>
                <LineChart labels={chartLabels} datasets={chartDataset} /> 
                <p className="mb-0 text-muted"><small>Bransje: {data.businessArea} i {data.tradeArea}</small></p>
            </div>
        </div>
    );
}

export default RelevantAlternatives;